export default "__VITE_ASSET__yn1sPsnh__"